import { render } from "./LayoutV1.vue?vue&type=template&id=33081eaa&scoped=true&ts=true"
import script from "./LayoutV1.vue?vue&type=script&lang=ts"
export * from "./LayoutV1.vue?vue&type=script&lang=ts"

import "./LayoutV1.vue?vue&type=style&index=0&id=33081eaa&lang=scss"
import "./LayoutV1.vue?vue&type=style&index=1&id=33081eaa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33081eaa"]])

export default __exports__